/* eslint-disable prefer-promise-reject-errors */
import axios from 'axios'
import qs from 'qs'

/**
 * * 这个接口建议不要用了，有bug，不好用
 * 这是一个通用的 http request，在不同的 http 请求下使用
 * * 为何会有这个接口？我们知道，在一个活动项目里面，经常会出现多方的 http api 请求等，他们的处理方式是不一样的, header 不一样，
 * * 回参判断不一样，入参也不一样，所以，这个接口应成为底层接口，你应该在你的业务上再封装一层A
 * * 在这里 showLoading/hideLoading/toastError/jumpToLogin 都是可以覆盖的，通过正确的覆盖，能得到预想的结果
 * * 想修改 headers ?，请通过 constructor.headers 进行修改
 * * 如何使用？new Req({ params }).request 进行使用
 * * 注意，每个接口应该单独 new 一个对象出来访问，而不是只使用一个 req 对象，避免在并发时出现问题
 * @type {{jumpToLogin(): void, toastError(*=): void, hideLoading(): void, showLoading(): void, _http(*, *, *=, *=, *=, *=): Promise<unknown>}}
 */
class Req {
  constructor (param = {}) {
    this.headers = param.headers || {
      'Content-Type': Req.contentTypes.json
    }
    if (param.showLoading) this.showLoading = param.showLoading
    if (param.hideLoading) this.hideLoading = param.hideLoading
    if (param.toastError) this.toastError = param.toastError
    if (param.mapSuccess) this.mapSuccess = param.mapSuccess
    if (param.onUploadProgress) this.onUploadProgress = param.onUploadProgress
  }

  showLoading () {
    console.log('loading')
  }

  hideLoading () {
    console.log('hide loading')
  }

  toastError (msg, response) {
    console.error('msg: ', msg, response)
  }

  // 判断 promise 成功的依据
  mapSuccess (respData) {
    return respData.success
  }

  /**
   * 统一 http 请求
   * 成功时输出 response.data
   * 失败时输出 error: { message, response, respData }
   * @param url {String} 带 `http` 的 url
   * @param data {Object} 会根据 你的 post/get 自动转化
   * @param method
   * @param needLoading
   * @param needToastError
   * @param needShowNetworkError
   * @returns {Promise<unknown>}
   * @private
   */
  request (url, data, method = 'post', needLoading = true, needToastError = true, needShowNetworkError = true) {
    // 0.
    method = method.toLocaleUpperCase()

    // 1.
    const headers = this.headers

    // 2.
    const requestData = {}
    if (method === 'POST') {
      if (headers['Content-Type'] === Req.contentTypes.xFrom) {
        requestData.data = qs.stringify(data)
      } else {
        requestData.data = data
      }
    } else {
      requestData.params = data
    }

    // 3.
    if (needLoading) this.showLoading()

    // 4.
    return new Promise((resolve, reject) => {
      axios({
        method,
        url,
        headers,
        ...requestData,
        onUploadProgress: progressEvent => {
          // progressEvent.lengthComputable
          // 属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
          // 如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
          this.onUploadProgress && this.onUploadProgress(progressEvent)
        },
      }).then(response => {
        if (response.status === 200) {
          const respData = response.data
          if (this.mapSuccess(respData)) {
            resolve(respData)
          } else {
            needToastError && this.toastError(respData)
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({
              response,
              respData
            })
          }
        }
      }).catch(error => {
        needLoading && this.hideLoading()
        if (error.response) {
          if (error.response.status >= 400) {
            error.message = '未找到请求链接'
          } else if (error.response.status >= 500) {
            error.message = '服务器错误，请稍候重试'
          }
        }
        if (!error.message) error.message = '网络连接，请稍候重试'
        if (needShowNetworkError) this.toastError(error)

        reject({
          message: error.message,
          response: error.response,
          respData: error.response && error.response.data
        })
      }).finally(() => {
        needLoading && this.hideLoading()
      })
    })
  }
}

/**
 * 提供便利的 contentTypes 集合
 * * json: application/json
 * * xFrom: application/x-www-form-urlencoded
 * @type {{json: string, xFrom: string}}
 */
Req.contentTypes = {
  json: 'application/json',
  xFrom: 'application/x-www-form-urlencoded',
}

export default Req
